import { LookupServiceDialogContainer } from './LookupServiceDialogContainer'

export const LookupServiceDialog = ({
  addServiceCallback,
  setCustomProps
}: {
  addServiceCallback?: (serviceIds: string[]) => void
  setCustomProps: (s: boolean) => void
}) => {
  return (
    <LookupServiceDialogContainer
      setCustomProps={setCustomProps}
      addServiceCallback={addServiceCallback}
    />
  )
}
